import { RouteType } from "routes/types";
import { lazy } from "react";

const Element = lazy(() => import("./index"));

const route: RouteType = {
  id: 1500,
  parentId: 1000,
  name: "EmailVerified",
  label: "EmailVerified",
  path: "email_verified",
  element: Element,
  footer: true,
  hidden: true,
  user: false,
  admin: false,
};

export default route;
